var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7143 2.6137H17.2857C17.7403 2.6137 18.1765 2.79432 18.4979 3.1158C18.8193 3.43729 19 3.87332 19 4.32799V21.4708C19 21.9255 18.8193 22.3616 18.4979 22.683C18.1765 23.0044 17.7403 23.1851 17.2857 23.1851H2.71429C2.25962 23.1851 1.82359 23.0044 1.5021 22.683C1.18062 22.3616 1 21.9255 1 21.4708V4.32799C1 3.87332 1.18062 3.43729 1.5021 3.1158C1.82359 2.79432 2.25962 2.6137 2.71429 2.6137H5.28571M6.14288 14.6165L8.71431 16.3308L13.8572 9.47363M12.5714 0.899414H7.42857C6.48181 0.899414 5.71429 1.66693 5.71429 2.6137V3.47084C5.71429 4.41761 6.48181 5.18513 7.42857 5.18513H12.5714C13.5182 5.18513 14.2857 4.41761 14.2857 3.47084V2.6137C14.2857 1.66693 13.5182 0.899414 12.5714 0.899414Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu5);
export default __webpack_public_path__ + "static/media/iconMenu5.515fdb09649f438b1d368f3a6cf1bab2.svg";
export { ForwardRef as ReactComponent };